import script from "./news-detail.vue?vue&type=script&setup=true&lang=js"
export * from "./news-detail.vue?vue&type=script&setup=true&lang=js"

import "./news-detail.vue?vue&type=style&index=0&id=67cd2852&lang=scss"

const __exports__ = script;

export default __exports__